import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import NotFound from '../views/NotFound.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/theme/:theme?',
    name: 'Theme',
    component: Home,
    alias: '/'
  },
  {
    path: '/type/:type?',
    name: 'Type',
    component: Home,
    alias: '/'
  },
  {
    path: '/(theme/)?:theme?/type/:type?',
    name: 'ThemeType',
    component: Home,
    alias: '/'
  },
  {
    path: '*',
    component: NotFound
  }
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: function(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
      // Or for Vue 3:
      // return {el: to.hash}
    } else {
      return { x: 0, y: 0 };
    }
  }
});
router.beforeEach((to, from, next) => {
  next();
});

export default router;
